/*=============================
=        Blog Categories      =
=============================*/

var categorySelect = document.getElementById('blog-categories');

if(categorySelect) {
	categorySelect.addEventListener('change', function() {
		window.location.href = this.value; 
	});
}